/**
 * Attaches the agent command kernel to window.__velostruct__.
 * All method implementations live in src/agent/ — this hook is only the
 * React lifecycle wrapper.
 */
import { useEffect } from 'react';
import { createBridgeApi } from '../agent';
export type { VelostructBridgeAPI } from '../agent';

export function useVelostructBridge(): void {
  useEffect(() => {
    window.__velostruct__ = createBridgeApi();
     
    console.info('[Velostruct] Agent bridge ready — window.__velostruct__ is available');
    return () => {
      delete window.__velostruct__;
    };
  }, []);
}
